export enum Route {
    USERS = '/users',
    STATISTICS = '/statistics',
    STATISTICS_DEVICE = '/statistics/device/',
    DEVICES = '/devices',
    SERVICE_DOWNTIME = '/service-downtime',
    HOME = '/home',
    MODELS = 'models'
}
